import type { Link } from '@wix/public-schemas'
import { NEW_TAB_TARGET } from './constants'
import type { AddressLinkData } from './linksDataTypes'

export const handleAddressLink = (linkData: AddressLinkData): Link => {
	const { address } = linkData
	return { id: linkData.id, href: `http://maps.google.com/maps?daddr=${encodeURI(address)}`, target: NEW_TAB_TARGET }
}
